import Vue from "vue"
export const selectionModule = {
  state: () => ({
    minDays: 7,
    maxDays: 30,
    defaultDaysCnt: 10,
    // daysCnt: 7,
    dateIn: null,
    dateOut: null,
    avilableGuestsCnt: 1,
    guestsCnt: 1,
    isPresent: false,
    variants: [],
    searchedVariantsKeys: null,
    advancedVariantsKeys: [],
    isVariantsFetching: false,
    selectedCategoryId: null,
    isSpaTour: false,
    isHealthTour: false,
    // selectedVariant: {},
    defaults: {
      cure: null,
      nutrition: null,
    },
    savedBookingInfo: {},
    isPrepayment: false,
    paymentMethod: `ukassa`,
    billType: null,
    checkoutTime: null,
    certificates: [],
    guests: [],
  }),

  getters: {
    getSpaTourThreshold: (state, getters, rootState, rootGetters) => () => {
      const defaultThreshold = 14;

      const settingsSpaTour = rootState.dictionaries?.settingsSpaTour;

      if (!settingsSpaTour || !settingsSpaTour['kluchi']) {
        return defaultThreshold;
      }

      const settings = settingsSpaTour['kluchi'];

      if (settings.openBefore) {
        const now = new Date();
        const openBeforeDate = new Date(settings.openBefore);
        const daysDiff = Math.ceil((openBeforeDate - now) / (1000 * 60 * 60 * 24));
        const result = Math.max(0, daysDiff);

        if (isNaN(result)) {
          console.log('error: ошибка преобразования дат из settings.openBefore');
          return defaultThreshold;
        } else {
          return result;
        }
      }

      if (settings.bookingPeriod) {
        return +settings.bookingPeriod;
      }

      return defaultThreshold;
    },
    getIsPresent: state => {
      return state.isPresent;
    },

    getIsPrepayment: state => {
      return state.isPrepayment;
    },

    getVariants: state => {
      return state.variants
    },

    getVariantByKey: state => key => {
      let variant = state.variants.find(variant => variant.key === key)
      return variant
    },

    getSelectedCategory: (state, getters, rootState, rootGetters) => {
      return state.selectedCategoryId ?
        rootGetters['dictionaries/getRoomCategoryById'](state.selectedCategoryId)
        : null
    },

    getPurchaserForSend: (state, getters, rootState, rootGetters) => {
      let purchaser = JSON.parse(JSON.stringify(rootGetters['guestsModule/getPurchaser']));
      return {
        lastName: purchaser.secondName,
        name: purchaser.firstName,
        secondName: purchaser.thirdName,
        birthday: purchaser.birthday,
        phone: purchaser.phone,
        email: purchaser.email,
      };
    },

    getPrices(state, getters, rootState, rootGetters) {
      if(!Object.keys(state.savedBookingInfo).length) return null
      const res = {}
      const certificatesSum = getters.getCertificatesSum
      const udsSum = +rootGetters[`loyalty/getUdsData`]?.canWrite || null
      res.main = +state.savedBookingInfo.ticketPrice - (udsSum || certificatesSum || 0)
      if(res.main < 1) res.main = 1
      res.prepayment = +state.savedBookingInfo?.prepaymentPrice
      res.extra = +state.savedBookingInfo?.extraServicePrice
      return res
    },

    getCertificatesSum(state) {
      return state.certificates.length ? state.certificates.reduce((acc, cur) => acc += +cur.price, 0) : 0
    },

    getDateIn(state) {
      return state.dateIn
    },

    getGuestsCnt(state) {
      return state.guests.reduce((acc, cur) => acc += +cur.value, 0)
    }
  },

  mutations: {
    setDateIn(state, ISODate) {
      state.dateIn = ISODate
    },

    setDateOut(state, ISODate) {
      state.dateOut = ISODate
    },

    setMinDays(state, cnt) {
      state.minDays = cnt
    },

    setDaysCnt(state, cnt) {
      state.daysCnt = cnt
    },

    setGuestsCnt(state, cnt) {
      state.guestsCnt = cnt
    },

    setAvilableGuestsCnt(state, cnt) {
      state.avilableGuestsCnt = cnt
    },

    setVariants(state, variants) {
      state.variants = variants
    },

    setIsVariantsFetching(state, bool) {
      state.isVariantsFetching = bool
    },

    setSearchedVariantsKeys(state, searchedVariantsKeys) {
      state.searchedVariantsKeys = searchedVariantsKeys
    },

    setAdvancedVariantsKeys(state, advancedVariantsKeys) {
      state.advancedVariantsKeys = advancedVariantsKeys
    },

    setSelectedCategoryId(state, selectedCategoryId) {
      state.selectedCategoryId = selectedCategoryId
    },

    setIsPresent(state, isPresent) {
      state.isPresent = isPresent
    },

    updateDefaults(state, payload) {
      Object.assign(state.defaults, payload)
    },

    setSavedBookingInfo(state, payload) {
      state.savedBookingInfo = payload
    },

    updateSavedBookingInfo(state, payload) {
      Object.assign(state.savedBookingInfo, payload)
    },

    setAdvancedVariants(state, payload) {
      state.advancedVariants = payload
    },

    setIsPrepayment(state, bool) {
      state.isPrepayment = Boolean(bool)
    },

    setIsSpaTour(state, bool) {
      state.isSpaTour = bool
    },

    setIsHealthTour(state, bool) {
      state.isHealthTour = bool
    },

    setPaymentMethod(state, str) {
      state.paymentMethod = str
    },

    setCheckoutTime(state, v) {
      state.checkoutTime = v
    },

    addCertificate(state, obj) {
      if(typeof obj === `object`) state.certificates.push(obj)
    },

    removeCertificate(state, code) {
      let index = state.certificates.findIndex((certificate) => certificate.code === code)
      if(index !== -1) state.certificates.splice(index, 1)
    },

    setBillType(state, v) {
      state.billType = v
    },

    updateGuests(state, arr) {
      const res = [...state.guests]
      arr.forEach(i => {
        const index = res.findIndex(y => y.id === i.id)

        if(index > -1) {
          res[index] = { ...res[index], ...i }
        } else {
          res.push(i)
        }

        Vue.set(state, 'guests', [...res]);
      })
    }
  },

  actions: {
    changeDateIn({state, commit}, ISODate) {
      commit('setDateIn', ISODate)
    },

    changeDateOut({state, commit}, ISODate) {
      commit('setDateOut', ISODate)
    },

    changeAvilableGuestsCnt({commit}, cnt) {
      commit('setAvilableGuestsCnt', cnt)
    },

    fetchVariants({commit, rootState}, params) {
      // let checkoutTime = rootState.dictionaries?.checkoutTime?.find(item => item?.active === true)
      // if (!checkoutTime) checkoutTime = rootState.dictionaries?.checkoutTime?.find(item => item?.default === true)
      const paramStr = new URLSearchParams(params).toString()
      let query = `/search/getAvailable/?${paramStr}`

      commit('setIsVariantsFetching', true)
      this._vm.$http
        .get(query)
        .then(resp => {
          let data = resp.data.data
          let variants = []
          let searchedVariantsKeys = []
          let advancedVariantsKeys = []

          // счетчик keys
          let keyCounter = 0

          // перебор результатов целевого поиска
          if(data.search.length > 0) {
            data.search.forEach(el => {
              keyCounter += 1

              let variant = {}
              Object.assign(variant, el)
              variant.key = keyCounter
              variants.push(variant)

              searchedVariantsKeys.push(keyCounter)
            })
          }

          // перебор результатов альтернативного поиска
          if(data.advancedSearch.length > 0) {
            data.advancedSearch.forEach(el => {
              keyCounter += 1

              let variant = {}
              Object.assign(variant, el)
              variant.key = keyCounter
              variants.push(variant)

              advancedVariantsKeys.push(keyCounter)
            })
          }

          commit('setVariants', variants)
          commit('setSearchedVariantsKeys', searchedVariantsKeys)
          commit('setAdvancedVariantsKeys', advancedVariantsKeys)
          commit('setDaysCnt', params.daysCnt)
          commit('setGuestsCnt', params.cnt)
          commit('setIsPresent', params.isPresent)
        })
        .catch(e => {
          console.error(e)
        })
        .finally(() => {
          commit('setIsVariantsFetching', false)
        })
    },

    selectVariant({state, getters, commit, dispatch, rootState, rootGetters}, key) {
      let selectedVariant = getters.getVariantByKey(key)
      let getCategoryData = rootGetters['dictionaries/getRoomCategoryById']
      let categoryData = getCategoryData(selectedVariant.roomCategoryId)
      let defaults = categoryData.defaults

      let guests = rootState.guestsModule.guestsList
      let newGuestsCnt = +state.guestsCnt
      let avilableGuestsCnt = +categoryData.capacity + +categoryData.capacityExtra

      let dates = selectedVariant.dateRange.split(`-`)
      let dateIn = dates[0].trim().split(`.`)
      let dateOut = dates[1].trim().split(`.`)
      let now = new Date()
      let daysCnt = ( new Date(`${dateOut[2]}-${dateOut[1]}-${dateOut[0]}`) - new Date(`${dateIn[2]}-${dateIn[1]}-${dateIn[0]}`) ) / 1000 / 60 / 60 / 24 + 1
      let minDays = rootState.selection.minDays

      let spaTour = rootGetters[`dictionaries/checkSpaTourAvailable`]
      let healthTour = rootGetters[`dictionaries/checkHealthTourAvailable`]

      commit('setDateIn', `${dateIn[2]}-${dateIn[1]}-${dateIn[0]}`)
      commit('setDateOut', `${dateOut[2]}-${dateOut[1]}-${dateOut[0]}`)
      const daysThreshold = getters.getSpaTourThreshold()

      if(
        spaTour
        && +daysCnt < +minDays
        && new Date(dateIn[2], +dateIn[1] - 1, dateIn[0]) < new Date(now.getFullYear(), now.getMonth(), now.getDate() + daysThreshold)
      ) {
        commit('setIsSpaTour', true)
        defaults = {
          ...defaults,
          cure: '3',
          nutrition: +categoryData.divisionId === 2 ? `2` : `1`
        }
      } else {
        commit('setIsSpaTour', false)
      }

      if(
        healthTour && +daysCnt >= 8 && +daysCnt < 11
      ) {
        commit('setIsHealthTour', true)
      } else {
        commit('setIsHealthTour', false)
      }

      if(!state.selectedVariantId || state.selectedVariantId !== selectedVariant.roomCategoryId) {
        commit('setSelectedCategoryId', selectedVariant.roomCategoryId)
        commit('updateDefaults', defaults)
        commit('setAvilableGuestsCnt', avilableGuestsCnt)
        dispatch('guestsModule/updateCommonFields', defaults, { root: true })
      }

      // инициализация гостей
      commit('guestsModule/resetGuests', null, { root: true })
      state.guests.forEach(i => {
        if(i.value) {
          for(let y = 0; y < i.value; y++) {
            dispatch('guestsModule/addGuest', { guestType: i.id }, { root: true })
          }
        }
      })

      // сброс у гостей типа лечения и питания на дефолтные
      dispatch('guestsModule/updateAllGuests', defaults, { root: true })
      dispatch('guestsModule/updateCommonFields', defaults, { root: true })
    },

    async saveBooking({state, commit, getters, dispatch, rootState, rootGetters}) {
      // todo: тут создание booking - мб здесь добавление плательщика
      let queryStatus = `OK`
      let checkoutTimeActive = rootState.selection?.checkoutTime
      if (!checkoutTimeActive) checkoutTimeActive = rootState.dictionaries?.checkoutTime?.find(item => item?.default === true)

      let data = {
        dateIn: state.dateIn,
        dateOut: state.dateOut,
        roomCategory: state.selectedCategoryId,
        guests: {},
        services: [],
        loyaltyPoints: 0,
        checkoutTime: checkoutTimeActive,
      }

      data.payer = getters.getPurchaserForSend

      data.guests = rootState.guestsModule.guestsList.reduce((acc, cur) => {
        let tmp = {
          primary: cur.isPurchaser,
          seat: cur.seat,
          seat_extra: cur.seatExtra,
          healthCard: cur.healthcard,
          person: {
            lastName: cur.secondName,
            name: cur.firstName,
            secondName: cur.thirdName,
            birthday: cur.birthday,
            phone: cur.phone,
            email: cur.email,
            guestType: cur.guestType,
            gender: cur.gender,
            passport: {
              // series: '0000',
              // number: '000000',
              // issueDate: '2022-01-01',
              // issueDepartment: 'отделением УВД Ленинского р-на города Перми',
              // issueDepartmentCode: '590-344',
            },
            address: {
              // region: '4f8b1a21-e4bb-422f-9087-d3cbf4bebc14',
              // regionName: 'Пермский край',
              // city: '4ffcde97-05e9-4a6e-bd51-3a984b41b7bd',
              // cityName: 'г Березники',
              // street: '33b6d40d-1030-492d-9238-ed838731de4e',
              // streetName: 'пр-кт Ленина',
              // house: '2d446b12-52da-490a-ac24-bca77650f2a2',
              // houseName: '24',
              // flat: '23',
            },
          },
          cure: cur.cure,
          nutrition: cur.nutrition,
        }

        acc.push(tmp)
        return acc
      }, [])

      data.services = rootState.extraServices.list.reduce((acc, cur) => {
        if(!cur.data.isSelected) return acc

        let tmp = {
          service: cur.id,
          cnt: cur.data.cnt || 1,
          dateStart: cur.data.dateStart,
          dateEnd: cur.data.dateEnd,
          additional: cur.data.additional,
        }

        acc.push(tmp)
        return acc
      }, [])

      rootState.isLoading = true
      await this._vm.$http
        .post('/cluster/save/', data)
        .then(resp => {
          let result = resp.data.data

          result.paymentPrice = result.price
          commit('setSavedBookingInfo', result)
        })
        .catch(e => {
          console.error(e)
          queryStatus = `error`
        })
        .finally(() => {
          rootState.isLoading = false
        })

      return queryStatus
    },

    updateSavedBookingInfo({state, commit, getters, dispatch, rootState, rootGetters}, payload) {
      commit('updateSavedBookingInfo', payload)
    }
  },

  namespaced: true,
}
